import React from "react";
import {
  CheckboxInputField,
  checkboxValidation,
  multipleValidations,
} from "@jsainsburyplc/id-ui-common";

import { Link } from "@sainsburys-tech/luna-link";

import {
  TERMS_AND_CONDITIONS,
  TERMS_REQUIRED,
} from "constants/registrationForm";
import { missionId } from "utils/urls";
import { missionNames } from "constants/missions";
import SectionContainer from "./SectionContainer";

const DEFAULT_TERMS_URL =
  "https://help.sainsburys.co.uk/help/terms-and-conditions/buying-online";

// Add mission-specific overrides here as needed
const termsUrlByMission = {
  [missionNames.SAVINGCARD]: "https://help.sainsburys.co.uk/help/products-savings",
};

const termsHref = termsUrlByMission[missionId] || DEFAULT_TERMS_URL;

const MyDetails = ({ termsData: { label } }) => (
  <SectionContainer label={label}>
    <CheckboxInputField
      data-testid="terms-and-conditions"
      name={TERMS_AND_CONDITIONS}
      validation={multipleValidations([checkboxValidation(TERMS_REQUIRED)])}
      info={
        "We want you to know exactly how our service works and why we need your registration details. Please state that you have read and agreed to these terms before you continue."
      }
      checkboxLabel={
        <span>
          I agree to the{" "}
          <Link
            href={termsHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            terms and conditions
          </Link>
        </span>
      }
    />
  </SectionContainer>
);

export default MyDetails;
